import { clsx } from 'clsx';
import { MarkdownRenderer } from 'src/components/MarkdownRenderer/MarkdownRenderer';
import moment from 'moment/moment';
import { AddFAQPopup } from 'src/components/KnowledgeBase/AddFAQPopup/AddFAQPopup';
import { useParams } from 'react-router-dom';
import type { ConversationMessage } from 'src/pages/ConversationsPage/conversationTypes';

interface ConversationUserMessageProps {
  message: ConversationMessage;
}

export const ConversationUserMessage = ({ message }: ConversationUserMessageProps) => {
  const { id } = useParams();
  return (
    <li
      key={`message-${message._id}`}
      className={clsx(
        'list-none flex flex-col text-sm font-medium text-ebony_opacity_70 items-start',
      )}
    >
      <div className={clsx('lg:max-w-[80%] flex flex-col items-start group')}>
        <div
          className={clsx(
            '[&_p:last]:mb-0 [&_p:last-of-type]:mb-0 rounded-sm-5 p-4 max-w-full bg-light border border-[#E3E6E880]',
          )}
        >
          <MarkdownRenderer>{message.body}</MarkdownRenderer>
        </div>
        <div
          className={
            'text-[11px] text-ebony_opacity_30 font-medium flex flex-row justify-between w-full gap-2.5'
          }
        >
          <AddFAQPopup projectId={id} message={message.body} />
          <p className={'opacity-0 group-hover:opacity-100 transition-opacity duration-300'}>
            {moment(message.created_at).format('lll')}
          </p>
        </div>
      </div>
    </li>
  );
};
